import React from 'react'
import { useNavigate } from 'react-router'
import { Button, CardRadioInput } from '@demandlocal/components'
import { FormProvider, useForm } from 'react-hook-form'
import { motion } from 'framer-motion'
import { ReactComponent as IconClose } from '../../images/icons/icon_close.svg'
import { ReactComponent as IconImport } from '../../images/icons/icon_import_large.svg'
import { ReactComponent as IconCreate } from '../../images/icons/icon_create_large.svg'
import { ReactComponent as IconGoogleAds } from '../../images/vendors/google_ads_logo.svg'
import { ReactComponent as IconFacebookAds } from '../../images/vendors/meta_logo.svg'
import { useDealership } from '../../store/zustand/dealershipStore'
import { useTranslation } from 'react-i18next'

type FieldValues = {
  campaign_type: 'import' | 'new'
}

export default function CampaignCreateTypeForm(): JSX.Element {
  const dealership = useDealership()
  const { t } = useTranslation('routes')
  const navigate = useNavigate()
  const formContext = useForm<FieldValues>()
  const {
    handleSubmit,
    formState: { isDirty },
  } = formContext

  const onSubmit = (values: { campaign_type: 'import' | 'new' }): void => {
    const { campaign_type } = values
    if (campaign_type) navigate(`./../${campaign_type}`)
  }

  return (
    <FormProvider {...formContext}>
      <motion.form
        onSubmit={handleSubmit(onSubmit)}
        className={'flex flex-1 h-full flex-col overflow-y-scroll'}>
        <div className={'py-5 flex justify-between items-center px-12'}>
          <h1 className={' text-3xl font-bold'}>Campaign source</h1>
          <IconClose
            className={'cursor-pointer'}
            onClick={(e) => {
              navigate(t('dealership.campaigns.list', { dealership }))
            }}
          />
        </div>
        <div className={'flex flex-col flex-1 justify-center items-center'}>
          <div className={'grid grid-cols-2 gap-5 h-fit px-12'}>
            <CardRadioInput
              icon={<IconCreate />}
              name={'campaign_type'}
              value={'new'}
              label={'Create campaigns'}
              description={'Create a campaign from scratch'}
              background={'white'}
            />
            <CardRadioInput
              icon={<IconImport />}
              name={'campaign_type'}
              value={'import'}
              label={'Import campaigns'}
              description={
                <div>
                  <h3>
                    Import campaigns from your Google Ads, Facebook Ads, or other sources
                  </h3>
                  <div className={'flex flex-row items-center justify-center gap-2 mt-4'}>
                    <IconGoogleAds className={'w-8 h-8'} />
                    <IconFacebookAds className={'w-8 h-8'} />
                  </div>
                </div>
              }
              background={'white'}
            />
          </div>
        </div>
        <motion.div
          layout
          layoutId={'buttons-container'}
          className={
            'h-20 items-center flex justify-between border-t-2 py-4 px-12 absolute bottom-0 w-full bg-white'
          }>
          <Button
            variant={'secondary'}
            onClick={(e) => {
              e.preventDefault()
              navigate(t('dealership.campaigns.list', { dealership }))
            }}>
            Cancel
          </Button>
          <Button variant={'primary'} type="submit" disabled={!isDirty}>
            Continue
          </Button>
        </motion.div>
      </motion.form>
    </FormProvider>
  )
}
